import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.sms-users', {
        url: '/sms-users',
        component: 'companyUserDirectoriesSaaspassUsersSmsUsers',
        resolve: {
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/sms-users/sms-users.state.js